import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import './styles/responsive.css'
import './i18n/config' // i18n vor App-Start laden

// Global styles
const globalStyles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  body {
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
      'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
      sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background-color: #f5f5f5;
    color: #333;
    line-height: 1.6;
  }
  
  #root {
    min-height: 100vh;
  }
  
  /* Animations */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Utility classes */
  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }
  
  /* Responsive design helpers */
  @media (max-width: 768px) {
    .desktop-nav {
      display: none !important;
    }
    
    .hamburger {
      display: flex !important;
    }
  }
  
  @media (min-width: 769px) {
    .mobile-menu {
      display: none !important;
    }
    
    .hamburger {
      display: none !important;
    }
  }
  
  /* Interactive elements */
  button, a {
    transition: all 0.2s ease-in-out;
  }
  
  button:hover, a:hover {
    transform: translateY(-1px);
  }
  
  button:active, a:active {
    transform: translateY(0);
  }
  
  /* Focus styles for accessibility */
  button:focus, a:focus, input:focus, textarea:focus, select:focus {
    outline: 2px solid #3498db;
    outline-offset: 2px;
  }
  
  /* Loading animation */
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
  @keyframes fadeIn {
    from { opacity: 0; transform: translateY(20px); }
    to { opacity: 1; transform: translateY(0); }
  }
  
  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }
  
  /* Card hover effects */
  .card-hover {
    transition: transform 0.2s, box-shadow 0.2s;
  }
  
  .card-hover:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0,0,0,0.15);
  }
  
  /* Form styles */
  input, textarea, select {
    transition: border-color 0.2s, box-shadow 0.2s;
  }
  
  input:focus, textarea:focus, select:focus {
    border-color: #3498db;
    box-shadow: 0 0 0 3px rgba(52, 152, 219, 0.1);
  }
  
  /* Button styles */
  .btn {
    display: inline-block;
    padding: 0.75rem 1.5rem;
    border: none;
    border-radius: 4px;
    font-size: 1rem;
    font-weight: 500;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: all 0.2s;
    line-height: 1.5;
  }
  
  .btn-primary {
    background-color: #3498db;
    color: white;
  }
  
  .btn-primary:hover {
    background-color: #2980b9;
  }
  
  .btn-secondary {
    background-color: #95a5a6;
    color: white;
  }
  
  .btn-secondary:hover {
    background-color: #7f8c8d;
  }
  
  .btn-success {
    background-color: #27ae60;
    color: white;
  }
  
  .btn-success:hover {
    background-color: #229954;
  }
  
  .btn-danger {
    background-color: #e74c3c;
    color: white;
  }
  
  .btn-danger:hover {
    background-color: #c0392b;
  }
  
  /* Disabled state */
  .btn:disabled, button:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    transform: none !important;
  }
  
  /* Text utilities */
  .text-center { text-align: center; }
  .text-left { text-align: left; }
  .text-right { text-align: right; }
  
  .text-muted { color: #7f8c8d; }
  .text-primary { color: #3498db; }
  .text-success { color: #27ae60; }
  .text-danger { color: #e74c3c; }
  .text-warning { color: #f39c12; }
  
  /* Spacing utilities */
  .mt-1 { margin-top: 0.25rem; }
  .mt-2 { margin-top: 0.5rem; }
  .mt-3 { margin-top: 1rem; }
  .mt-4 { margin-top: 1.5rem; }
  .mt-5 { margin-top: 3rem; }
  
  .mb-1 { margin-bottom: 0.25rem; }
  .mb-2 { margin-bottom: 0.5rem; }
  .mb-3 { margin-bottom: 1rem; }
  .mb-4 { margin-bottom: 1.5rem; }
  .mb-5 { margin-bottom: 3rem; }
  
  .p-1 { padding: 0.25rem; }
  .p-2 { padding: 0.5rem; }
  .p-3 { padding: 1rem; }
  .p-4 { padding: 1.5rem; }
  .p-5 { padding: 3rem; }
  
  /* Flexbox utilities */
  .d-flex { display: flex; }
  .flex-column { flex-direction: column; }
  .flex-row { flex-direction: row; }
  .justify-center { justify-content: center; }
  .justify-between { justify-content: space-between; }
  .align-center { align-items: center; }
  .align-start { align-items: flex-start; }
  .align-end { align-items: flex-end; }
  
  /* Grid utilities */
  .d-grid { display: grid; }
  .grid-gap-1 { gap: 0.25rem; }
  .grid-gap-2 { gap: 0.5rem; }
  .grid-gap-3 { gap: 1rem; }
  .grid-gap-4 { gap: 1.5rem; }
  .grid-gap-5 { gap: 3rem; }
`;

// Inject global styles
const styleSheet = document.createElement('style');
styleSheet.textContent = globalStyles;
document.head.appendChild(styleSheet);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
